import $ from 'jquery';

/**
 * Creates managed WooCommerce event listeners that auto-cleanup on re-trigger.
 * Solves memory leak issue where listeners accumulate on each WC event.
 *
 * @param {string|string[]} events - WC event(s) to listen for (e.g., 'updated_checkout', 'wc_fragments_refreshed')
 * @param {Function} callback - Function to call. Receives addCleanup function as argument.
 *
 * @example
 * onWcEvent('updated_checkout', (addCleanup) => {
 *     const btn = document.querySelector('.my-btn');
 *     const handler = () => console.log('clicked');
 *     btn.addEventListener('click', handler);
 *
 *     // Register cleanup - will be called before next event trigger
 *     addCleanup(() => btn.removeEventListener('click', handler));
 * });
 *
 * @example
 * // Multiple events
 * onWcEvent(['wc_fragments_refreshed', 'updated_shipping_method'], (addCleanup) => {
 *     // setup code...
 * });
 */
export const onWcEvent = (events, callback) => {
    const eventList = Array.isArray(events) ? events.join(' ') : events;
    let cleanupFns = [];

    const handler = () => {
        // Run all cleanup functions from previous invocation
        cleanupFns.forEach((fn) => {
            try {
                fn();
            } catch (e) {
                console.error('WC event cleanup error:', e);
            }
        });
        cleanupFns = [];

        // Provide addCleanup function to callback
        const addCleanup = (fn) => cleanupFns.push(fn);
        callback(addCleanup);
    };

    // Run immediately on initialization
    handler();

    // Re-run on WC events
    $(document.body).on(eventList, handler);
};
